import { FORM_BLOCK_LAYOUT_CLASS_NAME } from '@/components/blocks/primitives/form-block-layout';
import type { BlockStackAlign } from '@/lib/blocks/layout/block-stack-layout';
import type { GroupAlign } from '@/lib/blocks/layout/group-layout';
import { cn } from '@/lib/utils';
import type { PageBlock } from '@/types/block';

export type EditorContentAlign = BlockStackAlign | GroupAlign;
export type EditorVisualWidth = 'content' | 'full';

export function resolveEditorBlockVisualWidth(block: PageBlock): EditorVisualWidth {
  if (block.blockType === 'button') {
    return 'content';
  }

  return 'full';
}

export function getEditorBlockRootClassName(block: PageBlock): string | undefined {
  return block.blockType === 'form' ? FORM_BLOCK_LAYOUT_CLASS_NAME : undefined;
}

export function getEditorContentAnchorClassName({
  contentAlign,
  visualWidth,
  stretchToParent = false,
}: {
  contentAlign: EditorContentAlign;
  visualWidth: EditorVisualWidth;
  stretchToParent?: boolean;
}): string {
  if (visualWidth === 'full') {
    return cn('relative min-w-0 w-full max-w-full', stretchToParent && 'h-full');
  }

  return cn(
    'relative inline-block min-w-0 max-w-full',
    contentAlign === 'center' && 'mx-auto',
    contentAlign === 'end' && 'ml-auto',
  );
}
